// extracted by mini-css-extract-plugin
module.exports = {"linksContainer":"donate-module--linksContainer--3Xy11","column":"donate-module--column--Dc0yN"};